import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];
const ALLOWED_URI_REGEXP = /^(?:https?|mailto):/i;

let hookRegistered = false;
function ensureExternalLinkHook(): void {
  if (hookRegistered) {
    return;
  }
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if ((node as Element).tagName === 'A') {
      (node as Element).setAttribute('target', '_blank');
      (node as Element).setAttribute('rel', 'noopener noreferrer');
    }
  });
  hookRegistered = true;
}

@Pipe({
  name: 'safeWelcome',
  standalone: false,
})
export class WelcomeMessagePipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  constructor() {
    ensureExternalLinkHook();
  }

  transform(value: string | null | undefined): SafeHtml {
    if (!value) {
      return '';
    }

    const clean = DOMPurify.sanitize(value, {
      ALLOWED_TAGS,
      ALLOWED_ATTR,
      ALLOWED_URI_REGEXP,
    });

    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }
}
